/**
 * Mantém fora dos buscadores as rotas que não são conteúdo publicado.
 *
 * Renderizado uma única vez no `App`, e não nas views: as telas cobertas aqui
 * (busca, login, 404, edição) não passam pelo `View`, então não têm
 * `SeoMetaTags` — e por isso hoje não emitem `robots` nenhum.
 *
 * `follow` é deliberado: a página não deve aparecer no índice, mas os links
 * dela continuam valendo para o rastreador encontrar o conteúdo real.
 *
 * OS 0007/2026, Seção V, IV.
 */

import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import React from 'react';
import { useSelector } from 'react-redux';

import { shouldNotIndex } from './robots';

interface Props {
  pathname?: string;
}

export const SeoRobots: React.FC<Props> = ({ pathname }) => {
  const contentErrorStatus = useSelector(
    (state: any) => state.content?.get?.error?.status,
  );

  if (!shouldNotIndex({ pathname, contentErrorStatus })) return null;

  return (
    <Helmet>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
  );
};

export default SeoRobots;
